import React, { useState, lazy, useEffect } from 'react';

import { toast, ToastContainer } from 'react-toastify';
import {
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CRow,
} from '@coreui/react';

import API from 'src/utils/apiCalling';
import { config } from 'src/utils/apiUrl';
import swal from 'sweetalert';
import Alert from 'src/alert/alert';
import moment from 'moment';

const NomineeDetails = props => {
    let {
        getEmployeeDetailStatus,
        empStatus,
        empDetails,
        onClickActive,
    } = props;
    const api = new API();
    const [isDisabled, setIsDisabled] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [empNomineeDetails, setEmpNomineeDetails] = useState([]);
    const [isAlert, setIsAlert] = useState(false);
    const [isSubmit, setIsSubmit] = useState(true);
    const [alertMessage, setAlertMessage] = useState('');
    const [experienced, setExperienced] = useState('');
    const [updateNominee, setUpdateNominee] = useState([])
    const isAlertToggle = msg => {
        setIsAlert(!isAlert);
        setAlertMessage(msg);
    };
    const [nominee, setNominee] = useState({
        nominee_name: '',
        dob: '',
        relationship: '',
        percentage: '',
        other_relation: ''
    });

    const getTotalPercentage = (list) => {
        return list.reduce((sum, item) => sum + Number(item.percentage || 0), 0);
    };

    useEffect(() => {
        getNomineeDetails();
    }, []);

    const isAlertToggleClose = () => {
        setIsAlert(false);
    };

    const getNomineeDetails = async () => {
        let data = {
            user_id: empDetails && empDetails.id,
        };
        if (!data.user_id) {
            delete data.user_id;
        }
        let result = await api.get(config.getNomineeDetails, true, data);
        if (result && result.code == 200) {
            // if (empStatus && empStatus.nominee_details_status === 1) {
            setIsDisabled(true);
            setIsSubmit(false);
            setEmpNomineeDetails(result.data.Employee_nominee_details);
            // }
        } else {
            setIsDisabled(true);
            setEmpNomineeDetails([]);
        }
    };
    const saveNominee = async () => {
        const total = getTotalPercentage(empNomineeDetails);
        if (total !== 100) {
            toast.error(`Total percentage must be 100%. Current: ${total}%`);
            return;
        }
        let data = {
            empNomineeDetails: JSON.stringify(empNomineeDetails),
        };
        data.user_id = empDetails && empDetails.id;
        if (!data.user_id) {
            delete data.user_id;
        }
        swal({
            html: true,
            title: 'Are you sure?',
            text: `Are you sure to add Nominee Details`,
            icon: 'success',
            buttons: ['No, cancel it!', 'Submit'],
            dangerMode: true,
        }).then(async function (isConfirm) {
            if (isConfirm) {
                let result = await api.post(config.fillNomineeDetails, data);
                if (result && result.code === 200) {
                    toast.success(result && result.message);
                    // onClickActive(9);
                    setIsSubmit(false);
                    // getEmployeeDetailStatus();

                    getNomineeDetails();
                } else {
                    toast.error(result && result.message);
                }
            }
        });
    };

    const saveSingleNominee = async () => {
        let isSubmit = (
            nominee?.nominee_name != '' &&
            nominee?.dob != '' &&
            nominee?.relationship != '' &&
            nominee?.percentage != '' &&
            (nominee?.relationship !== 'other' || nominee?.other_relation !== '')
        );
        if (isSubmit) {
            if (Number(nominee.percentage) !== 100) {
                toast.error('Percentage must be 100 for single nominee');
                return;
            }
            let empNomineeDetails = [{ ...nominee }];
            let data = {
                empNomineeDetails: JSON.stringify(empNomineeDetails),
            };
            data.user_id = empDetails && empDetails.id;
            if (!data.user_id) {
                delete data.user_id;
            }
            swal({
                html: true,
                title: 'Are you sure?',
                text: `Are you sure to add Nominee Details`,
                icon: 'success',
                buttons: ['No, cancel it!', 'Submit'],
                dangerMode: true,
            }).then(async function (isConfirm) {
                if (isConfirm) {
                    let result = await api.post(config.fillNomineeDetails, data);
                    if (result && result.code === 200) {
                        toast.success(result && result.message);
                        // onClickActive(9);
                        setIsSubmit(false);
                        // getEmployeeDetailStatus();
                        getNomineeDetails();
                    } else {
                        toast.error(result && result.message);
                    }
                }
            });
        } else {
            toast.warning('Please add all fields');
        }
    };

    const updatenominee = async () => {
        const total = getTotalPercentage(updateNominee);
        if (total !== 100) {
            toast.error(`Total percentage must be 100%. Current: ${total}%`);
            return;
        }
        let data = {
            empNomineeDetails: JSON.stringify(updateNominee),
        };
        swal({
            html: true,
            title: 'Are you sure?',
            text: `Are you sure to update Nominee Details`,
            icon: 'success',
            buttons: ['No, cancel it!', 'Update'],
            dangerMode: true,
        }).then(async function (isConfirm) {
            if (isConfirm) {
                let result = await api.post(config.fillNomineeDetails, data);
                if (result && result.code == 200) {
                    toast.success(result && result.message);
                    setIsSubmit(false);
                    // getEmployeeDetailStatus();
                    getNomineeDetails();
                } else {
                    toast.error(result && result.message);
                }
            }
        });
    };

    const addMoreNominee = () => {
        if (
            !nominee.nominee_name ||
            !nominee.dob ||
            !nominee.relationship ||
            !nominee.percentage ||
            (nominee.relationship === 'other' && !nominee.other_relation)
        ) {
            toast.error('Please fill all the fields..');
            return;
        } else {

            const total = getTotalPercentage([...empNomineeDetails, nominee]);
            if (total > 100) {
                toast.error(`Total cannot exceed 100%. Current: ${total}%`);
                return;
            }

            setEmpNomineeDetails([...empNomineeDetails, nominee]);
            setUpdateNominee([...updateNominee, nominee]);
            setIsDisabled(false);
            setNominee({
                nominee_name: '',
                dob: '',
                relationship: '',
                percentage: '',
                other_relation: ''
            });
        }
    };

    const addMoreNomineeOnUpdate = () => {
        if (
            !nominee.nominee_name ||
            !nominee.dob ||
            !nominee.relationship ||
            !nominee.percentage ||
            (nominee.relationship === 'other' && !nominee.other_relation)
        ) {
            toast.error('Please fill all the fields..');
            return;
        } else {
            const total = getTotalPercentage([...empNomineeDetails, nominee]);
            if (total > 100) {
                toast.error(`Total cannot exceed 100%. Current: ${total}%`);
                return;
            }
            setEmpNomineeDetails([...empNomineeDetails, nominee]);
            setUpdateNominee([...updateNominee, nominee])
            setIsDisabled(false);
            setNominee({
                nominee_name: '',
                dob: '',
                relationship: '',
                percentage: '',
                other_relation: ''
            });
        }
    };

    const onChangeInputNomineeDetails = e => {
        const { name, value } = e.target;

        let updatedValue = value;

        if (name === 'dob') {
            updatedValue = value
                ? moment(value).format("YYYY-MM-DD")
                : '';
        }

        setNominee(prev => ({
            ...prev,
            [name]: updatedValue,
        }));
    };

    const deleteNominee = async id => {
        let data = {
            id: id,
        };
        swal({
            html: true,
            title: 'Are you sure?',
            text: `Are you sure to delete Nominee Details`,
            icon: 'success',
            buttons: ['No, cancel it!', 'Delete'],
            dangerMode: true,
        }).then(async function (isConfirm) {
            if (isConfirm) {
                let result = await api.get(
                    config.deleteNomineeDetails,
                    true,
                    data,
                );
                if (result && result.code === 200) {
                    toast.success(result && result.message);
                    getNomineeDetails();
                    // getEmployeeDetailStatus();
                } else {
                    toast.error(result && result.message);
                }
            }
        });
    };

    const deleteLocalNominee = (index) => {
        const updatedList = empNomineeDetails.filter((_, i) => i !== index);
        setEmpNomineeDetails(updatedList);

        // also update updateNominee if needed
        const updatedUpdateList = updateNominee.filter((_, i) => i !== index);
        setUpdateNominee(updatedUpdateList);
    };

    return (
        <div>
            {empNomineeDetails && empNomineeDetails.length > 0 && (
                <CRow>
                    <CCol xs="12">
                        <CCard>
                            <CCardHeader>
                                {' '}
                                <strong>Nominee Details</strong>
                            </CCardHeader>
                            <CCardBody>
                                {empNomineeDetails?.length > 0 &&
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Nominee Full Name</th>
                                                <th scope="col">DOB</th>
                                                <th scope="col">Relationship</th>
                                                <th scope="col">Percentage</th>
                                                {/* <th scope="col">Delete</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {empNomineeDetails &&
                                                empNomineeDetails.length > 0 &&
                                                empNomineeDetails.map(
                                                    (nominee, index) => (
                                                        <tr>
                                                            <td>{nominee.nominee_name}</td>
                                                            <td>
                                                                {nominee.dob && moment(
                                                                    nominee.dob
                                                                ).format('DD-MM-YYYY')}
                                                            </td>
                                                            <td>
                                                                {nominee.relationship === 'other'
                                                                    ? nominee.other_relation
                                                                    : nominee.relationship}
                                                            </td>
                                                            <td>{nominee.percentage}</td>
                                                            {/* <td>
                                                                                   {nominee.dob && <i
                                                                                       className="fa fa-trash"
                                                                                       aria-hidden="true"
                                                                                       style={{ color: 'red' }}
                                                                                       onClick={() =>
                                                                                           isSubmit
                                                                                               ? deleteLocalNominee(index)
                                                                                               : deleteNominee(nominee.id)
                                                                                       }
                                                                                   ></i>}
                                                                               </td> */}
                                                        </tr>
                                                    ),
                                                )}
                                            {!isSubmit && <button
                                                type="button"
                                                className="btn btn-danger mt-3"
                                                onClick={() => deleteNominee()}
                                            >
                                                Delete
                                            </button>}
                                        </tbody>
                                    </table>}
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            )}
            <div>
                <form>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label for="exampleInputEmail1">Nominee Full Name</label>
                                <input
                                    type="name"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    name="nominee_name"
                                    value={nominee.nominee_name}
                                    onChange={onChangeInputNomineeDetails}
                                    placeholder="Enter Nominee Name"
                                    disabled={disabled ? true : false}
                                />
                            </div>
                            <div className="form-group">
                                <label for="exampleInputEmail1">
                                    Relationship with Nominee{' '}
                                </label>
                                <select
                                    className="form-control"
                                    id="exampleFormControlSelect1"
                                    name="relationship"
                                    onChange={onChangeInputNomineeDetails}
                                    placeholder=""
                                    value={nominee.relationship}
                                >
                                    <option hidden>Select Relationship with nominee</option>
                                    <option value="father">Father</option>
                                    <option value="mother">Mother</option>
                                    <option value="spouse">Spouse</option>
                                    <option value="son">Son</option>
                                    <option value="daughter">Daughter</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            {nominee.relationship == 'other' && (
                                <div className="form-group">
                                    <label for="exampleInputEmail1">Specify the Relation</label>
                                    <input
                                        type="name"
                                        className="form-control"
                                        id="exampleInputEmail1"
                                        name="other_relation"
                                        value={nominee.other_relation}
                                        onChange={onChangeInputNomineeDetails}
                                        placeholder="Enter the relation"
                                    />
                                </div>)}
                            <div className="">
                                <button
                                    type="button"
                                    className="btn btn-info mt-5"
                                    onClick={
                                        isSubmit
                                            ? addMoreNominee
                                            : addMoreNomineeOnUpdate
                                    }
                                    style={{ color: 'white', backgroundColor: 'green' }}
                                    disabled={disabled ? true : false}
                                >
                                    <i className="fa fa-plus" aria-hidden="true"></i>&nbsp; Add
                                    Nominee
                                </button>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label for="exampleInputEmail1">DOB</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    // min={nominee.emp_work_experience_to}
                                    id="exampleInputEmail1"
                                    name="dob"
                                    value={nominee.dob}
                                    onChange={onChangeInputNomineeDetails}
                                    placeholder="Enter Nominee DOB"
                                    disabled={disabled ? true : false}
                                     onKeyDown={(e) => e.preventDefault()}   
                                    onPaste={(e) => e.preventDefault()} 
                                />
                            </div>
                            <div className="form-group">
                                <label for="exampleInputEmail1">Percentage</label>
                                <input
                                    type="name"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    name="percentage"
                                    value={nominee.percentage}
                                    onChange={onChangeInputNomineeDetails}
                                    placeholder="Enter Nominee Percentage"
                                    disabled={disabled ? true : false}
                                />
                            </div>
                            {empNomineeDetails &&
                                empNomineeDetails.length > 0 ? (
                                <button
                                    type="button"
                                    style={nominee?.relationship == 'other' ? { marginTop: '135px' } : { marginTop: '50px' }}
                                    className="btn btn-primary float-right"
                                    onClick={saveNominee}
                                >
                                    Submit
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn btn-primary float-right"
                                    style={nominee?.relationship == 'other' ? { marginTop: '135px' } : { marginTop: '50px' }}
                                    onClick={saveSingleNominee}
                                >
                                    Submit
                                </button>
                            )
                                // ) : (
                                //     <>
                                // <button
                                //     type="button"
                                //     className="btn btn-success float-right ml-1 mt-5"
                                //     onClick={() => onClickActive(9)}
                                // >
                                //     Next{' '}
                                //     <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                // </button> 
                                //         <button
                                //             type="button"
                                //             className="btn btn-info float-right"
                                //             style={nominee?.relationship == 'other' ? { marginTop: '135px' } : { marginTop: '50px' }}
                                //             onClick={updatenominee}
                                //             disabled={isDisabled ? true : false}
                                //         >
                                //             Update
                                //         </button>
                                //     </>
                                // )
                            }
                        </div>
                    </div>
                </form>
            </div>
            <Alert
                isAlert={isAlert}
                isAlertToggle={isAlertToggle}
                alertMessage={alertMessage}
                isAlertToggleClose={isAlertToggleClose}
            />
            <ToastContainer />
        </div>
    );
};
export default NomineeDetails;